import { httpHandler } from '../httpHandler'

const URI = '/company/branches'

export const post = body => httpHandler.post({url: URI, options: { body } });
export const get = (body) => httpHandler.get({url: URI, params: body});
export const getAutocomplete = (Text) => httpHandler.get({url: URI, params: {Text, SelectedPage: 1}});
export const remove = code => httpHandler.del({ url: `${URI}/${code}` });
